import dynamic from "next/dynamic";

export const DynamicPlusBlurbPopup = dynamic(() =>
  import(".").then(module => module.PlusBlurbPopup),
);
